import doctorSection from "../../components/doctorSection/index.vue";
import newsLetters from "../../components/newsLetters/index.vue";
import partenairesSection from "../../components/partenairesSection/index.vue";
import heroSection from "../../components/heroSection/index.vue";

export default {
  name: "doctorPage",
  components: {
    heroSection,
    doctorSection,
    newsLetters,
    partenairesSection
  },
  methods: {
    track() {
      this.$gtag.screenview({
        screen_name: 'Doctor page',
      })
      this.$gtag.pageview({
        page_path: '/doctor',
      })
    }
  }
};
